import * as React from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/tags/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "@/pages/tags/Model"
import { CrudProvider } from "@/context/crudContext"
import { useState } from "react"
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs"

export default function TagList() {
  const breadcrumbs = [{ label: "Dashboard", url: "/" }, { label: "Tag" }]

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Tags</h5>

        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      <CrudProvider>
        <TagTable />
      </CrudProvider>
    </>
  )
}

function TagTable() {
  return (
    <>
      <CustomTable
        label="Tags"
        columns={columns}
        apiPath="tags"
      />

      <Modal />
    </>
  )
}
